__turbopack_context__.v({
  "slider": "ImageComparisonSlider-module-scss-module__cYnPIq__slider",
  "slider__container": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__container",
  "slider__divider": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__divider",
  "slider__handle": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__handle",
  "slider__handle-icon": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__handle-icon",
  "slider__handle-icon-bar": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__handle-icon-bar",
  "slider__image": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__image",
  "slider__image-layer": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__image-layer",
  "slider__image-layer--after": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__image-layer--after",
  "slider__image-layer--before": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__image-layer--before",
  "slider__instructions": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__instructions",
  "slider__label": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__label",
  "slider__label--after": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__label--after",
  "slider__label--before": "ImageComparisonSlider-module-scss-module__cYnPIq__slider__label--before",
});
